import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cfa371da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row gy-5 gx-xl-8 pb-5" }
const _hoisted_2 = { class: "col-xxl-8" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header border-0 pt-5" }
const _hoisted_5 = { class: "card-title align-items-start flex-column" }
const _hoisted_6 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, /*#__PURE__*/_toDisplayString(""), -1))
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = { class: "justify-content-end position-relative mb-8 mt-5" }
const _hoisted_10 = { class: "svg-icon svg-icon-1 position-absolute ms-6 mt-3" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  class: "btn btn-primary text-active-primary mx-6 mb-8 mt-5",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_add_event"
}
const _hoisted_13 = { class: "svg-icon svg-icon-2" }
const _hoisted_14 = { class: "nav" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = { class: "card-body py-3" }
const _hoisted_19 = { class: "tab-content" }
const _hoisted_20 = {
  class: "tab-pane fade active show",
  id: "kt_table_widget_5_tab_1"
}
const _hoisted_21 = { class: "table-responsive" }
const _hoisted_22 = { class: "table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-140px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-100px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" })
  ])
], -1))
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "rounded-start" }
const _hoisted_26 = { class: "symbol symbol-45px me-2" }
const _hoisted_27 = {
  key: 1,
  class: "symbol-label svg-icon svg-icon-1 svg-icon-primary"
}
const _hoisted_28 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_29 = {
  key: 0,
  class: "symbol-label svg-icon svg-icon-1 svg-icon-warning ms-1"
}
const _hoisted_30 = { class: "text-muted fw-bold d-block" }
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = {
  key: 0,
  class: "badge badge-light fs-8"
}
const _hoisted_33 = {
  key: 1,
  class: "badge badge-light fs-8"
}
const _hoisted_34 = { class: "text-end" }
const _hoisted_35 = { class: "badge badge-white d-block fs-8" }
const _hoisted_36 = { class: "text-end round-end" }
const _hoisted_37 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_38 = {
  key: 1,
  class: "badge badge-light-primary"
}
const _hoisted_39 = {
  key: 0,
  class: "d-flex flex-stack flex-wrap pt-10"
}
const _hoisted_40 = { class: "fs-6 fw-bold text-gray-700" }
const _hoisted_41 = { class: "pagination" }
const _hoisted_42 = { class: "page-item previous" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "previous" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "page-item next" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "next" }, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  class: "tab-pane fade",
  id: "kt_table_widget_5_tab_2"
}
const _hoisted_50 = { class: "table-responsive" }
const _hoisted_51 = { class: "table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-140px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-100px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" })
  ])
], -1))
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "rounded-start" }
const _hoisted_55 = { class: "symbol symbol-45px me-2" }
const _hoisted_56 = {
  key: 1,
  class: "symbol-label svg-icon svg-icon-1 svg-icon-primary"
}
const _hoisted_57 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_58 = {
  key: 0,
  class: "symbol-label svg-icon svg-icon-1 svg-icon-warning ms-1"
}
const _hoisted_59 = { class: "text-muted fw-bold d-block" }
const _hoisted_60 = { class: "text-end" }
const _hoisted_61 = {
  key: 0,
  class: "badge badge-light fs-8"
}
const _hoisted_62 = {
  key: 1,
  class: "badge badge-light fs-8"
}
const _hoisted_63 = { class: "text-end" }
const _hoisted_64 = { class: "badge badge-white d-block fs-8" }
const _hoisted_65 = { class: "text-end round-end" }
const _hoisted_66 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_67 = {
  key: 1,
  class: "badge badge-light-primary"
}
const _hoisted_68 = {
  key: 0,
  class: "d-flex flex-stack flex-wrap pt-10"
}
const _hoisted_69 = { class: "fs-6 fw-bold text-gray-700" }
const _hoisted_70 = { class: "pagination" }
const _hoisted_71 = { class: "page-item previous" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "previous" }, null, -1))
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = ["onClick"]
const _hoisted_75 = { class: "page-item next" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "next" }, null, -1))
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = {
  class: "tab-pane fade",
  id: "kt_table_widget_5_tab_3"
}
const _hoisted_79 = { class: "table-responsive" }
const _hoisted_80 = { class: "table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-140px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-100px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" })
  ])
], -1))
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { class: "rounded-start" }
const _hoisted_84 = { class: "symbol symbol-45px me-2" }
const _hoisted_85 = {
  key: 1,
  class: "symbol-label svg-icon svg-icon-1 svg-icon-primary"
}
const _hoisted_86 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_87 = {
  key: 0,
  class: "symbol-label svg-icon svg-icon-1 svg-icon-warning ms-1"
}
const _hoisted_88 = { class: "text-muted fw-bold d-block" }
const _hoisted_89 = { class: "text-end" }
const _hoisted_90 = {
  key: 0,
  class: "badge badge-light fs-8"
}
const _hoisted_91 = {
  key: 1,
  class: "badge badge-light fs-8"
}
const _hoisted_92 = { class: "text-end" }
const _hoisted_93 = { class: "badge badge-white d-block fs-8" }
const _hoisted_94 = { class: "text-end round-end" }
const _hoisted_95 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_96 = {
  key: 1,
  class: "badge badge-light-primary"
}
const _hoisted_97 = {
  key: 0,
  class: "d-flex flex-stack flex-wrap pt-10"
}
const _hoisted_98 = { class: "fs-6 fw-bold text-gray-700" }
const _hoisted_99 = { class: "pagination" }
const _hoisted_100 = { class: "page-item previous" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "previous" }, null, -1))
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = ["onClick"]
const _hoisted_104 = { class: "page-item next" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "next" }, null, -1))
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = { class: "col-xxl-4" }
const _hoisted_108 = {
  key: 0,
  class: "mb-5 mb-xl-8"
}
const _hoisted_109 = { class: "card" }
const _hoisted_110 = { class: "card-body" }
const _hoisted_111 = { class: "mx-8" }
const _hoisted_112 = { class: "bold fs-6 text-primary" }
const _hoisted_113 = { class: "bold fs-6 text-success" }
const _hoisted_114 = { class: "bold fs-6 text-warning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SubmissionChart = _resolveComponent("SubmissionChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t("classInfo.submissions")), 1),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid w-200px ps-14",
                placeholder: _ctx.t('course.search'),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchHomeworks()))
              }, null, 40, _hoisted_11), [
                [_vModelText, _ctx.search]
              ])
            ]),
            _createVNode(_component_router_link, { to: "submissions/add" }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("course.exercise")), 1)
                ])
              ]),
              _: 1
            }),
            _createElementVNode("ul", _hoisted_14, [
              _createElementVNode("li", _hoisted_15, [
                _createElementVNode("a", {
                  class: "nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 active",
                  "data-bs-toggle": "tab",
                  href: "#kt_table_widget_5_tab_1",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentPage = 1))
                }, _toDisplayString(_ctx.t("course.assign")), 1)
              ]),
              _createElementVNode("li", _hoisted_16, [
                _createElementVNode("a", {
                  class: "nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1",
                  "data-bs-toggle": "tab",
                  href: "#kt_table_widget_5_tab_2",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.finishedCurrentPage = 1))
                }, _toDisplayString(_ctx.t("course.completed")), 1)
              ]),
              _createElementVNode("li", _hoisted_17, [
                _createElementVNode("a", {
                  class: "nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4",
                  "data-bs-toggle": "tab",
                  href: "#kt_table_widget_5_tab_3",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.manquantCurrentPage = 1))
                }, _toDisplayString(_ctx.t("course.missing")), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("table", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageRecords, (item, index) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        key: index,
                        to: `/${item.type}/${item.id}`,
                        custom: ""
                      }, {
                        default: _withCtx(({ navigate }) => [
                          _createElementVNode("tr", {
                            onClick: navigate,
                            class: "hover-tr"
                          }, [
                            _createElementVNode("td", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                (item.marked)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(`symbol-label svg-icon svg-icon-1 svg-icon-${
                                  item.type == 'quiz' ? 'info' : 'warning'
                                }`)
                                    }, [
                                      (item.type == 'quiz')
                                        ? (_openBlock(), _createBlock(_component_inline_svg, {
                                            key: 0,
                                            src: "media/icons/duotune/art/art002.svg"
                                          }))
                                        : (_openBlock(), _createBlock(_component_inline_svg, {
                                            key: 1,
                                            src: "media/icons/duotune/art/art005.svg"
                                          }))
                                    ], 2))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                      (item.type == 'quiz')
                                        ? (_openBlock(), _createBlock(_component_inline_svg, {
                                            key: 0,
                                            src: "media/icons/duotune/art/art002.svg"
                                          }))
                                        : (_openBlock(), _createBlock(_component_inline_svg, {
                                            key: 1,
                                            src: "media/icons/duotune/art/art005.svg"
                                          }))
                                    ]))
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("a", _hoisted_28, _toDisplayString(item.title), 1),
                              (item.spec)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen003.svg" })
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_30, _toDisplayString(item.subject.name), 1)
                            ]),
                            _createElementVNode("td", _hoisted_31, [
                              (item.submited && item.submission.note)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(item.submission.note) + "/20", 1))
                                : (item.marked)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.t("course.marked")), 1))
                                  : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_34, [
                              _createElementVNode("span", _hoisted_35, _toDisplayString(item.submission
                                ? _ctx.moment(item.submission.createdAt).format(
                                    "MMMM Do YYYY, H:mm"
                                  )
                                : "-"), 1)
                            ]),
                            _createElementVNode("td", _hoisted_36, [
                              (item.submited)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.t("course.completed")), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.t("course.missing")), 1))
                            ])
                          ], 8, _hoisted_24)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ])
                ])
              ]),
              (_ctx.pageRecords.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, " Showing " + _toDisplayString(_ctx.perPage * (_ctx.currentPage - 1) + 1) + " to " + _toDisplayString(_ctx.currentPage == _ctx.totalPages
                      ? _ctx.filteredHomeworks.length
                      : _ctx.perPage * _ctx.currentPage) + " of " + _toDisplayString(_ctx.filteredHomeworks.length) + " entries ", 1),
                    _createElementVNode("ul", _hoisted_41, [
                      _createElementVNode("li", _hoisted_42, [
                        _createElementVNode("button", {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.currentPage = 1)),
                          class: "page-link"
                        }, _hoisted_44)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: i,
                          class: _normalizeClass(["page-item", i == _ctx.currentPage ? 'active' : ''])
                        }, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.currentPage = i),
                            class: "page-link"
                          }, _toDisplayString(i), 9, _hoisted_45)
                        ], 2))
                      }), 128)),
                      _createElementVNode("li", _hoisted_46, [
                        _createElementVNode("button", {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.currentPage = _ctx.totalPages)),
                          class: "page-link"
                        }, _hoisted_48)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("table", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.finishedPageRecords, (item, index) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        key: index,
                        to: `/${item.type}/${item.id}`,
                        custom: ""
                      }, {
                        default: _withCtx(({ navigate }) => [
                          _createElementVNode("tr", {
                            onClick: navigate,
                            class: "hover-tr"
                          }, [
                            _createElementVNode("td", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                (item.marked)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(`symbol-label svg-icon svg-icon-1 svg-icon-${
                                  item.type == 'quiz' ? 'info' : 'warning'
                                }`)
                                    }, [
                                      (item.type == 'quiz')
                                        ? (_openBlock(), _createBlock(_component_inline_svg, {
                                            key: 0,
                                            src: "media/icons/duotune/art/art002.svg"
                                          }))
                                        : (_openBlock(), _createBlock(_component_inline_svg, {
                                            key: 1,
                                            src: "media/icons/duotune/art/art005.svg"
                                          }))
                                    ], 2))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_56, [
                                      (item.type == 'quiz')
                                        ? (_openBlock(), _createBlock(_component_inline_svg, {
                                            key: 0,
                                            src: "media/icons/duotune/art/art002.svg"
                                          }))
                                        : (_openBlock(), _createBlock(_component_inline_svg, {
                                            key: 1,
                                            src: "media/icons/duotune/art/art005.svg"
                                          }))
                                    ]))
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("a", _hoisted_57, _toDisplayString(item.title), 1),
                              (item.spec)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen003.svg" })
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_59, _toDisplayString(item.subject.name), 1)
                            ]),
                            _createElementVNode("td", _hoisted_60, [
                              (item.submited && item.submission.note)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(item.submission.note) + "/20", 1))
                                : (item.marked)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.t("course.marked")), 1))
                                  : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_63, [
                              _createElementVNode("span", _hoisted_64, _toDisplayString(item.submission
                                ? _ctx.moment(item.submission.createdAt).format(
                                    "MMMM Do YYYY, H:mm"
                                  )
                                : "-"), 1)
                            ]),
                            _createElementVNode("td", _hoisted_65, [
                              (item.submited)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.t("course.completed")), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_ctx.t("course.missing")), 1))
                            ])
                          ], 8, _hoisted_53)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ])
                ])
              ]),
              (_ctx.finishedPageRecords.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, " Showing " + _toDisplayString(_ctx.perPage * (_ctx.finishedCurrentPage - 1) + 1) + " to " + _toDisplayString(_ctx.finishedCurrentPage == _ctx.finishedTotalPages
                      ? _ctx.finishedHomeworks.length
                      : _ctx.perPage * _ctx.finishedCurrentPage) + " of " + _toDisplayString(_ctx.finishedHomeworks.length) + " entries ", 1),
                    _createElementVNode("ul", _hoisted_70, [
                      _createElementVNode("li", _hoisted_71, [
                        _createElementVNode("button", {
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.finishedCurrentPage = 1)),
                          class: "page-link"
                        }, _hoisted_73)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.finishedTotalPages, (i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: i,
                          class: _normalizeClass(["page-item", i == _ctx.finishedCurrentPage ? 'active' : ''])
                        }, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.finishedCurrentPage = i),
                            class: "page-link"
                          }, _toDisplayString(i), 9, _hoisted_74)
                        ], 2))
                      }), 128)),
                      _createElementVNode("li", _hoisted_75, [
                        _createElementVNode("button", {
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.finishedCurrentPage = _ctx.finishedTotalPages)),
                          class: "page-link"
                        }, _hoisted_77)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("table", _hoisted_80, [
                  _hoisted_81,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manquantPageRecords, (item, index) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        key: index,
                        to: `/${item.type}/${item.id}`,
                        custom: ""
                      }, {
                        default: _withCtx(({ navigate }) => [
                          _createElementVNode("tr", {
                            onClick: navigate,
                            class: "hover-tr"
                          }, [
                            _createElementVNode("td", _hoisted_83, [
                              _createElementVNode("div", _hoisted_84, [
                                (item.marked)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(`symbol-label svg-icon svg-icon-1 svg-icon-${
                                  item.type == 'quiz' ? 'info' : 'warning'
                                }`)
                                    }, [
                                      (item.type == 'quiz')
                                        ? (_openBlock(), _createBlock(_component_inline_svg, {
                                            key: 0,
                                            src: "media/icons/duotune/art/art002.svg"
                                          }))
                                        : (_openBlock(), _createBlock(_component_inline_svg, {
                                            key: 1,
                                            src: "media/icons/duotune/art/art005.svg"
                                          }))
                                    ], 2))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_85, [
                                      (item.type == 'quiz')
                                        ? (_openBlock(), _createBlock(_component_inline_svg, {
                                            key: 0,
                                            src: "media/icons/duotune/art/art002.svg"
                                          }))
                                        : (_openBlock(), _createBlock(_component_inline_svg, {
                                            key: 1,
                                            src: "media/icons/duotune/art/art005.svg"
                                          }))
                                    ]))
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("a", _hoisted_86, _toDisplayString(item.title), 1),
                              (item.spec)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_87, [
                                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen003.svg" })
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_88, _toDisplayString(item.subject.name), 1)
                            ]),
                            _createElementVNode("td", _hoisted_89, [
                              (item.submited && item.submission.note)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(item.submission.note) + "/20", 1))
                                : (item.marked)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_91, _toDisplayString(_ctx.t("course.marked")), 1))
                                  : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_92, [
                              _createElementVNode("span", _hoisted_93, _toDisplayString(item.submission
                                ? _ctx.moment(item.submission.createdAt).format(
                                    "MMMM Do YYYY, H:mm"
                                  )
                                : "-"), 1)
                            ]),
                            _createElementVNode("td", _hoisted_94, [
                              (item.submited)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_95, _toDisplayString(_ctx.t("course.completed")), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString(_ctx.t("course.missing")), 1))
                            ])
                          ], 8, _hoisted_82)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ])
                ])
              ]),
              (_ctx.manquantPageRecords.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                    _createElementVNode("div", _hoisted_98, " Showing " + _toDisplayString(_ctx.perPage * (_ctx.manquantCurrentPage - 1) + 1) + " to " + _toDisplayString(_ctx.manquantCurrentPage == _ctx.manquantTotalPages
                      ? _ctx.manquantHomeworks.length
                      : _ctx.perPage * _ctx.manquantCurrentPage) + " of " + _toDisplayString(_ctx.finishedHomeworks.length) + " entries ", 1),
                    _createElementVNode("ul", _hoisted_99, [
                      _createElementVNode("li", _hoisted_100, [
                        _createElementVNode("button", {
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.manquantCurrentPage = 1)),
                          class: "page-link"
                        }, _hoisted_102)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manquantTotalPages, (i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: i,
                          class: _normalizeClass(["page-item", i == _ctx.manquantCurrentPage ? 'active' : ''])
                        }, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.manquantCurrentPage = i),
                            class: "page-link"
                          }, _toDisplayString(i), 9, _hoisted_103)
                        ], 2))
                      }), 128)),
                      _createElementVNode("li", _hoisted_104, [
                        _createElementVNode("button", {
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.manquantCurrentPage = _ctx.manquantTotalPages)),
                          class: "page-link"
                        }, _hoisted_106)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_107, [
      (_ctx.updatedChart)
        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
            _createElementVNode("div", _hoisted_109, [
              _createVNode(_component_SubmissionChart, {
                "widget-classes": "card-xl-stretch mb-5 mb-xl-8",
                height: 300,
                title: _ctx.t('course.submissionsState'),
                description: _ctx.t('course.submissionsStateTitle'),
                data: _ctx.homeworks
              }, null, 8, ["title", "description", "data"]),
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.t("course.nbtotalExercises", { nb: _ctx.homeworks.length })), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.t("course.finishedExercises", { nb: _ctx.completedHomeworks })), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.t("course.notFinishedExercises", {
                      nb: _ctx.homeworks.length - _ctx.completedHomeworks,
                    })), 1)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}